import Icon from "@mui/icons-material/EventTwoTone";
// import List from "./list";
import Edit from "./edit";
import Create from "./create";

export default {
  // list: List,
  edit: Edit,
  create: Create,
  icon: Icon,
  label: "Events",
  options: { label: "Event" },
  name: "events",
};
